if (!customElements.get('occ-home-reviews')) {
  customElements.define('occ-home-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.reviews = [...this.querySelectorAll('[data-och-review]')];
      if (!this.reviews.length) return;
      this.index = 0;
      this.dialog = this.querySelector('dialog');
      this.querySelector('.och-review-actions').hidden = false;
      this.classList.add('och-enhanced');
      this.show(0);
      this.querySelector('[data-och-prev]').addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-och-next]').addEventListener('click', () => this.show(this.index + 1), options);
      this.querySelector('[data-och-read]').addEventListener('click', () => {
        const review = this.reviews[this.index];
        this.querySelector('[data-och-author]').textContent = review.querySelector('figcaption').childNodes[0].textContent.trim();
        this.querySelector('[data-och-quote]').replaceChildren(review.querySelector('.och-full-review > div').cloneNode(true));
        this.dialog.showModal();
      }, options);
      this.querySelector('[data-och-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        const box = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) this.dialog.close();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const i = this.reviews.findIndex(review => review.dataset.blockId === event.detail.blockId);
        if (i !== -1) this.show(i);
      }, options);
    }
    show(index) {
      this.index = (index + this.reviews.length) % this.reviews.length;
      this.reviews.forEach((review, i) => { review.hidden = i !== this.index; });
      this.querySelector('[data-och-counter]').textContent = `${String(this.index + 1).padStart(2, '0')} / ${String(this.reviews.length).padStart(2, '0')}`;
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
  });
}
